<template>
  <!-- <div class="pb-2 pt-2 border-b border-solid border-gray-100 dark:border-darkblue-600"> -->
  <div class="pb-4">
    <label class="text-sm font-semibold text-secondary-600 block mb-1 ml-4">{{ nombre }}</label>
    <div class="flex flex-row justify-center">
      <div
        class="filters-applied flex flex-row w-full flex-wrap border-solid border-primary-100 dark:border-darkblue-600 border rounded-3xl p-2"
      >
        <base-filter-tag-item-searches
          v-for="tag in finalTags"
          :key="tag[0]"
          :tag="tag"
        />
      </div>
      <div class="p-4">
        <base-button-icon name="check" size="xs" iconSize="sm" mode="primary" class="mb-2" @click="applySearch"/>
        <base-button-icon name="trash" size="xs" iconSize="sm" mode="secondary" @click="deleteSearch"/>
        <!-- <el-popconfirm
          confirm-button-text='Sí'
          cancel-button-text='No'
          hide-icon='true'
          title="¿Estás seguro de que quieres eliminar la búsqueda?"
        >
          <base-button-icon slot="reference" name="trash" size="xs" iconSize="sm" mode="secondary"/>
        </el-popconfirm> -->
      </div>
    </div>
  </div>
</template>

<script>
import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'

export default {
  name: 'base-search-item',
  props: {
    tags: {
      type: [Array],
      required: true
    },
    id: {
      type: Number,
      required: true,
      default: -1
    },
    nombre: {
      type: String,
      required: true
    }
  },
  data: function () {
    return { multipleFilters: TIPOS_FILTER_MULTIPLE, }
  },
  computed: {
    hasTags: function () {
      return this.tags.length > 0
    },
    finalTags: function () {
      const finalTags = this.tags
      const multipleTags = finalTags.filter(tag => this.isMultipleTag(tag))
        .map(tag => { tag[2] = tag[2].map((x, i) => [tag[0] + (i + 1), tag[1], this.tryParse(x), ...tag.slice(3), i]); return tag })
      multipleTags.forEach(tag => finalTags.splice(finalTags.findIndex(ftag => ftag[0] === tag[0]), 1, ...tag[2]))
      return finalTags
    },
  },
  methods: {
    isMultipleTag: function (tag) {
      return this.multipleFilters.some(x => x.NombreTag === tag[0]) && Array.isArray(tag[2])
    },
    deleteSearch: function () {
      this.$emit('deleteSearch', this.id)
    },
    applySearch: function () {
      const tagsToObj = this.convertTagsToObject()
      this.$emit('applySearch', tagsToObj)
    },
    convertTagsToObject () {
      const tags = this.tags
      let obj = {}
      for (let i = 0; i < tags.length; i++) {
        const objAux = {
          label: tags[i][1],
          value: tags[i][2],
          labelValue: tags[i][3],
          extraparams: tags[i].extraparams || null
        }
        const objAux2 = { [tags[i][0]]: objAux }
        obj = Object.assign(obj, objAux2)
      }
      return obj
    },
    tryParse: function (json) {
      try {
        return JSON.parse(json)
      } catch (error) {
        return json
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
